export const MOBILE_SESSION_STATE = {
  PENDING: "PENDING",
  PHONE_OPENED: "PHONE_OPENED",
  FRONT_CAPTURED: "FRONT_CAPTURED",
  BACK_CAPTURED: "BACK_CAPTURED",
  SUBMITTED: "SUBMITTED",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  EXPIRED: "EXPIRED",
  CANCELLED: "CANCELLED",
} as const;

export type MobileSessionState =
  (typeof MOBILE_SESSION_STATE)[keyof typeof MOBILE_SESSION_STATE];
